module.exports = __webpack_public_path__ + "img/所有者.9037db45.svg";